import { actions } from "./actions";
const { ACTION_BEGIN, ERROR } = actions;

const initialState = {
  loading: false,
};

export default function responseReducer(state = initialState, action: any) {
  const { type, data, err } = action;

  switch (type) {
    case ACTION_BEGIN:
      const stateClone = { ...state, ...data };
      return {
        ...stateClone,
      };
    case ERROR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    default:
      return state;
  }
}
